import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Home from "./pages/Home";
import MobileAppDevelopment from "./pages/services/MobileAppDevelopment";
import WebDevelopment from "./pages/services/WebDevelopment";
import EcommerceDevelopment from "./pages/services/EcommerceDevelopment";
import UIUXDesign from "./pages/services/UIUXDesign";
import CloudDevOpsInfrastructure from "./pages/services/CloudDevOpsInfrastructure";
import AIMLDevelopment from "./pages/services/AIMLDevelopment";
import WhatsAppFloat from "./components/WhatsAppFloat/WhatsAppFloat";
import DigitalMarketing from "./pages/services/DigitalMarketing";
import BallAdventuresPrivacy from "./pages/legal/BallAdventuresPrivacy";
import SlidingToonsPrivacy from "./pages/legal/SlidingToonsPrivacy";
import "./App.scss";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/services/mobile-app-development"
              element={<MobileAppDevelopment />}
            />
            <Route
              path="/services/web-development"
              element={<WebDevelopment />}
            />
            <Route
              path="/services/ecommerce-development"
              element={<EcommerceDevelopment />}
            />
            <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
            <Route
              path="/services/cloud-devops-infrastructure"
              element={<CloudDevOpsInfrastructure />}
            />
            <Route
              path="/services/ai-ml-development"
              element={<AIMLDevelopment />}
            />
            <Route
              path="/services/digital-marketing"
              element={<DigitalMarketing />}
            />
            <Route
              path="/ball-adventures/privacy-policy"
              element={<BallAdventuresPrivacy />}
            />
            <Route
              path="/sliding-toons/privacy-policy"
              element={<SlidingToonsPrivacy />}
            />
          </Routes>
          <WhatsAppFloat />
        </div>
      </Router>
    </Provider>
  );
}

export default App;
